import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '../config/translations';

Vue.use(VueI18n);

const SUPPORTED = Object.keys(messages);

function pickInitialLocale() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('language');
    if (fromQuery && SUPPORTED.includes(fromQuery)) return fromQuery;

    const stored = localStorage.getItem('harvia-language');
    if (stored && SUPPORTED.includes(stored)) return stored;
  } catch (e) {
    // window or localStorage not available — fall through
  }
  return 'fi';
}

const i18n = new VueI18n({
  locale: pickInitialLocale(),
  fallbackLocale: 'fi',
  messages,
});

export default i18n;
